import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EmployeeCard from "./EmployeeCard/EmployeeCard";
import UserCard from "./UserCard/UserCard";
import { useAppDispatch } from "toolkit/hooks";
import { getEmployee } from "toolkit/employees/employees.thunks";
import styles from "./EmployeePage.module.sass";
import { userAPI } from "libs/apiClient/User";

const deps = ["system.user.edit", "system.employee.edit"];
export const EmployeePage: FC = () => {
	const dispatch = useAppDispatch();

	const [isRefresh, setRefresh] = useState<boolean>(false);
	const { employeeId, userId } = useParams();

	const refresh = () => {
		setRefresh((prevState) => !prevState);
	};
	const [editRule, setEditRule] = useState({
		employee: true,
		user: true,
	});
	useEffect(() => {
		if (employeeId) dispatch(getEmployee({ employeeId }));
		if (userId) dispatch(getEmployee({ userId }));
		//eslint-disable-next-line
	}, [employeeId, userId, isRefresh]);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, deps).then(({ data }) => {
			setEditRule({
				user: !data.includes("system.user.edit"),
				employee: !data.includes("system.employee.edit"),
			});
		});
	}, []);
	return (
		<div className={styles.wrapper}>
			<EmployeeCard disabled={editRule.employee} refresh={refresh} />
			<UserCard disabled={editRule.user} />
		</div>
	);
};

export default EmployeePage;
